<template>
    <div class="row">
        <ContentOrLoading class="tw:w-full">
            <div v-if="!loadingZonas">
                <div class="col-12" v-if="!soloCambiarZona">
                    <transition name="fade" mode="out-in">
                        <div key="renmovar" id="renovar">
                            <RenovacionComponent 
                                @renovar="renovar" 
                                :precios="precios" 
                                @seleccionarZona="seleccionarZonaRenovacion"
                            />
                        </div>
                    </transition>
                </div>
                <div class="col-12 mt-4">
                    <transition name="fade" mode="out-in">
                        <div key="mapa" id="mapa">
                            <NuevasAltasComponent 
                                v-if="recargar && place.tipo_proceso_taquilla == 1" 
                                :renovacion="renovacion" 
                                :zonas="zonas" 
                                @goTo="goTo" 
                                :place="place"
                            />

                            <template v-if="place.tipo_proceso_taquilla == 2">
                                <SeleccionarRegionConSecciones
                                    @terminar="goTo"
                                />
                            </template>

                            <template v-if="place.tipo_proceso_taquilla == 3">
                                <h2>Compra mapa general</h2>
                            </template>
                        </div>
                    </transition>
                </div>
            </div>
        </ContentOrLoading>
    </div>
</template>

<script>
    import NuevasAltasComponent from '@/components/backend/stepper/components/NuevasAltasComponent';
    import RenovacionComponent from '@/components/backend/stepper/components/RenovacionComponent';
    import SeleccionarRegionConSecciones from '../components/secciones/SeleccionarRegionConSecciones.vue';

    export default {
        props: ['precios', 'soloCambiarZona'],
        data() {
            return {
                zonas: null,
                renovacion: 0,
                recargar: true,
                loadingZonas: true
            }
        },
        created() {
            if(this.place.tipo_proceso_taquilla == 1) {
                this.getZonas();
            } else {
                // Tipos 2 (secciones) y 3 (mapa general) no cargan zonas en este paso:
                // usan su propio flujo (SeleccionarRegionConSecciones / mapa general).
                // Sin este reset, loadingZonas queda en true y la página muestra
                // el loader infinito.
                this.loadingZonas = false;
            }
        },
        computed: {
            place() {
                return this.$store.getters.getRecinto;
            }
        },
        methods: {
            seleccionarZonaRenovacion() {
                this.renovacion = 1;
                this.recargar = false;
                this.$nextTick(() => {
                    this.recargar = true;
                });
                this.$scrollTo('#mapa');
            },
            goTo(paso, zona, abono) {
                this.$emit('goTo', paso, zona, abono);
            },
            getZonas() {
                this.loadingZonas = true;
                const params = {
                    filters: {
                        renovacion: this.renovacion,
                        place_id: this.place.id
                    },
                }
                this.$store.dispatch(this.config.getVuexAlias('zonas.index'), params).then(res => {
                    this.zonas = res.data;
                    if (this.place) {
                        return this.getZonasAnexas();
                    }
                }).then(() => {
                    this.loadingZonas = false;
                }).catch(() => {
                    this.loadingZonas = false;
                });
            },
            renovar(abonado) {
                if (this.loadingZonas) return;

                var paso = false;
                if (this.zonas) {
                    for (var i in this.zonas) {
                        if ((abonado.asiento && this.zonas[i].id == abonado.asiento.region_id) || (abonado.plaza && this.zonas[i].id === abonado.plaza.region_id)) {
                            paso = true;
                            this.goTo(2, this.zonas[i], abonado);
                        }
                    }
                }

                if (!paso) {
                    if (abonado.plaza && abonado.plaza.region_id) {
                        this.goTo(2, {
                            id: abonado.plaza.region_id,
                            name: abonado.plaza.region_name || abonado.plaza.section_name || '',
                            precios: abonado.plaza.precios || [],
                        }, abonado);
                    } else {
                        this.goTo(1, null, abonado);
                    }
                }
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            getZonasAnexas() {
                const params = {
                    filters: {},
                    lista_id: this.$store.getters.getListaId,
                    recinto_id: this.place.id
                }

                return this.$store.dispatch(this.config.getVuexAlias('back.abonos.taquilla.regiones-anexas'), params).then(res => {
                    let anexas = res.data.data;

                    anexas.forEach(zona => {
                        const descuentos = [];
                        zona.precios.forEach(precio => {
                            if (precio.descuentos) {
                                descuentos.push(...precio.descuentos);
                            }
                        });
                        zona.precios = descuentos;
                    });

                    this.zonas = this.zonas.concat(anexas);
                    this.$emit('setZonas', this.zonas);
                })
            }
        },
        components: {
            NuevasAltasComponent, RenovacionComponent, SeleccionarRegionConSecciones
        }
    }
</script>
